import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Clear from '@material-ui/icons/Clear';

const IconContainer = styled.div`
  cursor: pointer;
`;

const RemoveButton = ({
  onClick,
}) => (
  <IconContainer onClick={onClick}>
    <Clear />
  </IconContainer>
);

RemoveButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RemoveButton;
